// src/components/Projects.jsx
import React from 'react';
import '../styles/styles.css';

const Projects = () => {
  return (
    <section className="projects" id="projects">
      <h2>My Projects</h2>
      <div className="project-grid">
        <div className="project-card">
          <h3>E-Commerce Store</h3>
          <p>A responsive Shopify store with custom theme and product filtering.</p>
        </div>
        <div className="project-card">
          <h3>Amazon PPC Dashboard</h3>
          <p>React-based dashboard for visualizing campaign performance in real-time.</p>
        </div>
        <div className="project-card">
          <h3>Portfolio Website</h3>
          <p>Custom-built React portfolio with animations and dark theme.</p>
        </div>
      </div>
    </section>
  );
};

export default Projects;
